document.addEventListener('DOMContentLoaded', function(){

	// fetch('/test/', {
	// 	method: 'get',
	// 	credentials: 'include'
	// }).then(response => {
	// 	return response.json();
	// }).then(resp => {
	// 	console.log(resp);
	// });
	const openMenuBtn = document.querySelector('.burger'),
				header = document.querySelector('.h');

	openMenuBtn.addEventListener('click', function() {
		if (header.classList.contains('h--opened')) {
			header.classList.remove('h--opened');
			document.body.style.overflow = ''
		} else {
			header.classList.add('h--opened');
			document.body.style.overflow = 'hidden'
		}
	});

	document.addEventListener('scroll', function() {
    if (window.scrollY > 0) {
        header.classList.add('h--scrolled');
    } else {
        header.classList.remove('h--scrolled');
    }
	});

	const mainSlider = document.querySelector('.main-slider__slider');
	if (mainSlider) {
		new Swiper(mainSlider, {
			// slidesPerView: 'auto',
			spaceBetween: 20,
			// slideToClickedSlide: true,

			// watchSlidesVisibility: true,
			// watchSlidesProgress: true,

			// threshold: 10,
			// shortSwipes: false,
			pagination: {
				el: document.querySelector('.main-slider__pagination'),
				clickable: true
			},
			breakpoints: {
        1024: {
          slidesPerView: 'auto'
        }
      }
		});

		if (window.innerWidth >= 768) {
			const slides = mainSlider.querySelectorAll('.swiper-slide');
			slides.forEach((slide, index) => {
				slide.addEventListener('click', () => {
					// Remove active class from all slides
					slides.forEach(s => s.classList.remove('swiper-slide-active'));
					// Add active class to hovered slide
					slide.classList.add('swiper-slide-active');
				});
			});
		}
	}

	/*
	* Accordions
	*/
	const accs = document.querySelectorAll('.acc__header'),
		preopenedAcc = document.querySelectorAll('.acc--active');

	accs.forEach(acc => {
		acc.addEventListener('click', function () {
			this.closest('.acc').classList.toggle('acc--active');
			const panel = this.nextElementSibling;
			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + 'px';
			}
		});
	});

	preopenedAcc.forEach(acc => {
		const panel = acc.querySelector('.acc__content');
		if (panel.style.maxHeight) {
			panel.style.maxHeight = null;
		} else {
			panel.style.maxHeight = panel.scrollHeight + 'px';
		}
	})


	// Telephone
	const telephoneInputs = document.querySelectorAll('[data-input-tel]');
	telephoneInputs.forEach(function(telephoneInput){
		IMask(telephoneInput, {
			mask: '+{7}(000)000-00-00'
		});
		telephoneInput.removeAttribute('data-not-inited');
	});


	/*
	* Form init
	*/
	function initSimpleForm(form) {

		var requireElements = form.querySelectorAll('[required], .js-validate'),
			submitBtn = form.querySelector('.js-btn-submit'),
			agreeCheck = form.querySelector('.js-form-check-rules'),
			state = submitBtn.textContent;
	
		function clearFormErrors() {
			var texts = form.querySelectorAll('.booking__form-error:not(.hidden)');
			texts.forEach(function(text){
				text.classList.add('hidden');
			});
	
			var styles = form.querySelectorAll('.has-error');
			styles.forEach(function(style){
				style.classList.remove('has-error');
			});
		}
	
		function removeSingleErrorNode(){
			var isErrorNode = this.classList.contains('has-error');
	
			if (isErrorNode) {
				this.classList.remove('has-error');
				var errorText = this.closest('.booking__form-igroup').querySelector('.booking__form-error');
				if (errorText) {
					errorText.classList.add('hidden');
				}
			}
		}
	
		function scrollToFirstError() {
			var errEl = form.querySelector('.has-error');
	
			if (errEl && !isScrolledIntoView(errEl)) {
				errEl.closest('.booking__form-igroup').scrollIntoView({
					behavior: 'smooth'
				});
			}
		}
	
		function applyAjaxResult(data) {
	
			if (!data.err) {
				if (data.message) {
					var successTarget = form.querySelector('.js__result');
					successTarget.innerHTML = data.message;
					successTarget.classList.remove('hidden');
				}
			} else {
	
				data.elements.forEach(function(el){
					var errEl = form.querySelector('[name="'+el.errName+'"]');
						if (errEl) {
							errEl.classList.add('has-error');
							var errText = errEl.closest('.booking__form-igroup').querySelector('.booking__form-error');
							errText.textContent = el.message;
							errText.classList.remove('hidden');
						}
				});
	
				scrollToFirstError();

				submitBtn.disabled = false;
			}
	
			submitBtn.textContent = state;
		}
	
		requireElements.forEach(function(el){
			el.addEventListener('input', removeSingleErrorNode);
			el.addEventListener('change', removeSingleErrorNode);
		});
	
		if (agreeCheck) {
			agreeCheck.addEventListener('change', function() {
				submitBtn.disabled = !this.checked;
			});
		}
		
		form.setAttribute('novalidate', '');
		form.addEventListener('submit', function(e){
			e.preventDefault();
	
			clearFormErrors();
	
			var bError = false;
			requireElements.forEach(function(el){
				
				if (!el.checkValidity() || (el.hasAttribute('data-input-tel') && el.value.length < 16) ) {
					var errorType = el.validity.valueMissing ? 'valueMissing' : 'valueInvalid';
					var errorEl = el.closest('.input-line').querySelector('.input-line__inline-error');
					if (errorEl) {
						errorEl.innerHTML = el.dataset[errorType];
						errorEl.classList.remove('hidden');
					}
					el.classList.add('has-error');
	
					bError = true;
				}
			});
			
			if (bError) {
				scrollToFirstError();
				return;
			}
	
			let data = new FormData(form);
			submitBtn.disabled = true;
			submitBtn.textContent = submitBtn.dataset.wait;
	
			fetch(form.getAttribute('action'), {
				method: form.getAttribute('method'),
				body: data
			}).then(response => {
				return response.json();
			}).then(data => {
				applyAjaxResult(data);
			}).catch(function(error) {
				console.error(error);
			});
		});
	}
	
	var forms = document.querySelectorAll('form.js-simple-submit');
	if (!forms.length) {
		return;
	}

	forms.forEach(form => {
		initSimpleForm(form);
	});
});